import { Box, Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import ButtonGroup from '../../common/components/ButtonGroup';
import { RepoTypes } from 'common-types';
import { resolveRepoIcon } from 'common-icons';
import { IssueDetails } from '../../issues/common/types/issues-types';

const PermissionDeniedForm: FC<PermissionDeniedFormProps> = props => {
  const { classes } = useStyles();

  const { onClose, selectedIssue, onNavigate, errorMessage } = props;

  const RepoIcon = resolveRepoIcon(
    selectedIssue?.app?.type as RepoTypes,
    selectedIssue?.app.fakeApp,
  );

  return (
    <>
      <Box display='flex' flexDirection='column'>
        <Box flexGrow={1} ml={2} display='flex' alignItems='start'>
          <Typography variant='body2' color='text.primary'>
            {`${errorMessage} for the following resource`}
          </Typography>
        </Box>
        <Box display='flex' mb={2} ml={2} alignItems='start'>
          <div>{RepoIcon && <RepoIcon className={classes.repoIcon} />}</div>
          <Typography variant='body2' ml={2}>
            {selectedIssue.app.name}
          </Typography>
        </Box>
        <Box mb={2} ml={2}>
          <Typography variant='h6' color='text.primary'>
            {`Please navigate to the connectors screen to update your ${selectedIssue?.app?.type} token`}
          </Typography>
        </Box>
      </Box>
      <Box display='flex' alignItems='end'>
        <ButtonGroup
          onCancel={onClose}
          onClick={onNavigate}
          isLoading={false}
          buttonCancelLabel='Cancel'
          buttonCancelTooltip='Cancel operation'
          buttonActionLabel='Navigate'
          buttonActionTooltip='Navigate to connectors'
          buttonActionColor='primary'
          isActionDisabled={false}
        />
      </Box>
    </>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  repoIcon: {
    width: '1rem',
    height: '1rem',
    flexShrink: 0,
  },
}));

interface PermissionDeniedFormProps {
  onClose: () => void;
  onNavigate: () => void;
  open: boolean;
  selectedIssue: IssueDetails;
  errorMessage: string;
}

export default PermissionDeniedForm;
